import Swiper from 'swiper/bundle';

const caseSlider = () => {

  const sliderElements = document.querySelectorAll('.js-case-slider');

  sliderElements.forEach(element => {
    const pagination = element.querySelector('.swiper-pagination');
    const slideLength = element.querySelectorAll('.swiper-slide');


    if (slideLength.length === 1) {
      return;
    }

    let mainSwiper = new Swiper(element, { //eslint-disable-line
      loop: true,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
        type: 'bullets',
      },
      a11y: {
        prevSlideMessage: '前のスライドへ',
        nextSlideMessage: '次のスライドへ',
        slideLabelMessage: '{{index}}枚目のスライド',
        paginationBulletMessage: '{{index}}枚目のスライドを表示',
      },
    });
  });

};


export default () => {
  caseSlider();
};
